
<template>
	<EagleTap version="pro" :tapContext="tapContext" />
</template>
<script>
import EagleTap from './EagleTap'
import { appSale } from '../../baseData'

export default {
	data () {
		return {
			tapContext: appSale.pro
		}
	},

	components: {
		EagleTap
	}
}
</script>
